import {
  CONTENT_EDITOR,
  IMAGE_GENERATOR,
  MERCH,
  MERCH_MANAGER_EDITOR,
  UPLOAD,
  YT_THUMBNAIL_CREATOR,
} from "../routes/routes";

export const NavigationObj = () => {
  const headerItems = [
    {
      name: "Creative Tools",
      subNav: [
        {
          name: "Social Image Creator ",
          href: `/${IMAGE_GENERATOR}/Analysis-Articles`,
        },
        // { name: "Email Image Creator ", href: `/${EMAIL_IMAGE_GENERATOR}` },
        {
          name: "Youtube Thumbnail Creator ",
          href: `/${YT_THUMBNAIL_CREATOR}`,
        },
        {
          name: "Content Editor",
          href: `/${CONTENT_EDITOR}`,
        },
      ],
    },
    /* {
      name: "Website Changelog",
      href: "https://changelog.gom.digital",
    }, */
    {
      name: "File Uploader",
      href: `/${UPLOAD}`,
      /* subNav: [
        {
          name: "Dashboard",
          href: `/${UPLOAD}`,
        },
        {
          name: "General",
          href: `/${UPLOAD}/${GENERAL}`,
        },
        { name: "Dividend Feed", href: `/${UPLOAD}/${DIVIDEND_FEED}` },
        {
          name: "Trading Hours",
          href: `/${UPLOAD}/${TRADING_HOURS}`,
        },
        {
          name: "Legal Documents",
          href: `/${UPLOAD}/${LEGAL_DOCUMENTS}`,
        },
      ], */
    },
    /*  {
      name: "Trustpilot",
      href: `/${TRUSTPILOT_INVS}`,
    }, */
   /*  {
      name: "Credit Bonus",
      href: `/${CREDIT_BONUS}`,
    }, */
    {
      name: "Merchandise",
      subNav: [
        {
          name: "Merchandise",
          href: `/${MERCH}`,
        },

        {
          name: "Merchandise Manager",
          href: `/${MERCH_MANAGER_EDITOR}`,
        },
      ],
    },
  ];

  return headerItems;
};

export const FooterItems = () => {
  const footerItems = [
    {
      title: "SITE MAP",
      contents: [
        {
          name: "Social Image Creator",
          href: `/${IMAGE_GENERATOR}/Analysis-Articles`,
        },

        {
          name: "File Uploader",
          href: `/${UPLOAD}`,
        },
        {
          name: "Merchandise",
          href: `/${MERCH}`,
        },
        /*  {
          name: "Changelog",
          href: "https://changelog.gom.digital",
        }, */
      ],
    },
    {
      title: "MORE RESOURCES",
      contents: [
        {
          name: "Branding Guidelines",
          href: "https://firebasestorage.googleapis.com/v0/b/go-marketing-apps.appspot.com/o/general%2FBrand%20Guidelines_dir%2FBrand%20Guidelines.pdf?alt=media",
        },
        /*  {
          name: "Logo Packs",
          href: "https://lp.gomarkets.com/brand/GO-Markets-Brand-Guidelines.pdf",
        }, */
      ],
    },
  ];

  return footerItems;
};
